import { useEffect } from "react";
import "@/App.css";
import PitchDeck from "@/components/PitchDeck";

function App() {
  useEffect(() => {
    const remove = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.remove();
    };
    remove();
    const observer = new MutationObserver(remove);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return <PitchDeck />;
}

export default App;
